"use client";

import classNames from "classnames";
import Link from "next/link";
import { ReactNode, useRef, useState } from "react";
import { GrFormNextLink } from "react-icons/gr";
import styles from "./navbar-button.module.scss";
import { IconType } from "react-icons/lib";

export type MenuLinkButtonProps = {
  url: string;
  name: ReactNode;
  prefixIcon?: IconType;
  description?: string;
  color?: "lavender" | "greenYellow" | "dodgerBlue" | "default";
};

export type MenuLinkProps = {
  name: string;
  prefixIcon?: IconType;
  direction?: "right" | "left";
  type?: "solid" | "outline";
  size?: "small" | "large";
  columns?: number;
  links: MenuLinkButtonProps[];
};

export const LinkMenuBtn = ({
  links,
  name,
  prefixIcon,
  type = "outline",
  size = "large",
  direction = "left",
  columns = 3,
}: MenuLinkProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);
  //   const pathname = usePathname();

  const handleMenuOpen = () => {
    if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
    setIsMenuOpen(true);
  };

  const handleMenuClose = () => {
    timeoutIdRef.current = setTimeout(() => {
      setIsMenuOpen(false);
    }, 200);
  };

  const PrefixIcon = prefixIcon;

  return (
    <div
      className={styles.navbarBtnMenuWrapper}
      onMouseOver={handleMenuOpen}
      onMouseOut={handleMenuClose}
    >
      <button
        className={classNames(
          styles.navbarBtn,
          isMenuOpen && styles.active,
          styles[type],
        )}
      >
        {PrefixIcon && <PrefixIcon size={20} />}
        {name}
      </button>
      {isMenuOpen && (
        <div
          className={classNames(styles.navbarBtnMenuHolder, styles[direction])}
        >
          <div
            className={styles.navbarBtnMenu}
            style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
          >
            {links.map((link) => {
              const LinkPrefixIcon = link.prefixIcon;

              return (
                <Link key={link.url} href={link.url}>
                  <button
                    className={classNames(
                      styles.subBtn,
                      link.color && styles[link.color],
                      styles[size],
                    )}
                  >
                    <span>
                      {LinkPrefixIcon && <LinkPrefixIcon size={20} />}
                      {link.name}
                    </span>
                    <p>{link.description}</p>
                    <GrFormNextLink size={20} className={styles.icon} />
                  </button>
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
